import { Divider, Stack } from "@mui/material";
import { IconLock } from "src/components/icons-mui/lock";
import { Typography } from "src/components-mui/base/typography/typography";
import { CBDetailsAccordion } from "src/components-mui/pages/detail/certificate-box/components/details-accordion";
import { CBFooter } from "src/components-mui/pages/detail/certificate-box/components/footer";
import { CBHeader } from "src/components-mui/pages/detail/certificate-box/components/header/header";
import { InfoBox } from "src/components-mui/pages/detail/certificate-box/components/info-box";
import { CBInvestedCapital } from "src/components-mui/pages/detail/certificate-box/components/invested-capital";
import { CBPricesNotTicking } from "src/components-mui/pages/detail/certificate-box/components/prices";
import { SpacedContainer } from "src/components-mui/pages/detail/certificate-box/components/spaced-container";
import {
    CBCertificateFee,
    CBExchangeRatio,
    CBEmission,
    CBLiquidationFigure,
    CBPerformanceFee,
    CBTradingVolume,
} from "src/components-mui/pages/detail/certificate-box/components/statistics";
import { useCertificateBoxContext } from "src/components-mui/pages/detail/certificate-box/context";

const BARRED_MESSAGE_TEST_ID = "barred-message";

export const CertificateBoxBarred = () => {
    const { dict, selectedCertificate: certificate } = useCertificateBoxContext();
    const isHiddenCertificate = certificate.isHidden;

    return (
        <>
            <CBHeader />
            <SpacedContainer>
                <CBPricesNotTicking />
                <Divider />
                <Stack spacing={1}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                    <CBInvestedCapital />
                </Stack>
                <Divider />

                <CBDetailsAccordion>
                    <Stack spacing={1}>
                        <CBEmission />
                        <CBLiquidationFigure />
                        <CBTradingVolume />
                        {isHiddenCertificate && <CBExchangeRatio />}
                    </Stack>
                    <Divider sx={{ pt: 2 }} />
                </CBDetailsAccordion>

                <InfoBox icon={<IconLock sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography
                        data-test-id={BARRED_MESSAGE_TEST_ID}
                        sx={{
                            fontSize: "sm",
                        }}
                    >
                        {dict.barredMessage}
                    </Typography>
                </InfoBox>

                <CBFooter />
            </SpacedContainer>
        </>
    );
};
